import { v4 as uuid } from 'uuid';

import { EmployeeFragment, TaskCreateInput, TaskTagsBase_TaskTagFragment } from 'src/generated/mloop-graphql';

export type TaskCreateInputWrapper = TaskCreateInput & {
  assignee?: Pick<EmployeeFragment, 'id' | 'fullName' | 'internalProfilePictureUrl'> | undefined | null;
  taskTags?: TaskTagsBase_TaskTagFragment[] | undefined | null;
  taskCreatorId?: string | undefined | null;
};

/**
 * Generates a stable task ID to be used as an idempotency key for task creation.
 * This ID should be generated once when the task creation flow starts and reused
 * for all retry attempts to prevent duplicate task creation.
 * @returns A new UUID to be used as the task ID
 */
export const generateIdempotencyTaskId = (): string => uuid();

const emptyInterviewPlan = (customJobStageId: string) => [
  {
    id: uuid(),
    index: 0,
    jobStageId: customJobStageId,
    jobStageInterviews: [],
    locked: false,
  },
];

export const getTaskCreateInput = (
  task: TaskCreateInputWrapper,
  orgBreakImprovementsEnabled: boolean
): TaskCreateInput => {
  const { assignee: _assignee, taskTags: _taskTags, ...rest } = task;

  if (orgBreakImprovementsEnabled) {
    delete rest.customInterviewPlan;
  } else if (rest.customInterviewPlan?.length === 0) {
    // If there is no plan, create an empty plan before saving
    rest.customInterviewPlan = emptyInterviewPlan(rest.customJobStageId);
  }

  return {
    ...rest,
  };
};
